
import { Route, Routes } from 'react-router-dom';
import './App.css';
import { SignIn } from './components/Auth/SignIn';
import SignUp from './components/Auth/SignUp';
import Market from './components/containers/Market';
import Dashboard from './components/containers/Dashboard';
// import { Holding } from './components/Holdings/Holdings';
// import { Order } from './components/Orders/Orders';
import { PrivateRoute } from './components/PrivateRoute/PrivateRoute';
function App() {
  return (
    <div className="App">
    
        <Routes>
          <Route path= "/" element= {<SignUp/>} ></Route>
          <Route path= "/login" element= {<SignIn/>} ></Route>
          <Route path="/marketwatch"
          element={
            <PrivateRoute>
               <Market/>
            </PrivateRoute>
          }
        />
         <Route
         path="/dashboard/*"
          element={
            <PrivateRoute>
               <Dashboard/>
            </PrivateRoute>
          }
        />
        </Routes>
         
    </div>
  );
}

export default App;
